import { Component,OnInit } from '@angular/core';
import {MatrimoniService} from '../services/matrimoni.service';
import {Matrimonio} from '../beans/matrimonio';

@Component({
  selector: 'catalogo-matrimoni-component',
  templateUrl: './catalogo-matrimoni.component.html',
  styleUrls: ['./catalogo-matrimoni.component.css']
})
export class CatalogoMatrimoniComponent implements OnInit {
  
  matrimoni:Matrimonio[];

  constructor (private matrimonioService:MatrimoniService){}

  ngOnInit():void{
  	this.matrimonioService.getMatrimoni().then(matrimoni=>this.matrimoni=matrimoni);
  }
}


// WEBPACK FOOTER //
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/catalogo/catalogo-matrimoni.component.ts